import React, { useEffect, useState } from "react";
import { Form, Col,notification, Row, Typography, Button, Image, Upload, message, Input, } from "antd";
import { EditOutlined, LoadingOutlined, PlusOutlined, CloseOutlined } from "@ant-design/icons";
import type { UploadChangeParam } from "antd/es/upload";
import type { RcFile, UploadFile, UploadProps } from "antd/es/upload/interface";
import { useAppDispatch, useAppSelector } from "@/config/store";
import * as yup from 'yup';
import { UpdateListUserInfo } from "../user-manage.reducer";
import { UserInfo } from "@/shared/model/user-info.model";
import { translations } from '@/i18n/i18n';
import { useTranslation } from 'react-i18next';


const { Title, Text } = Typography;

const getBase64 = (img: RcFile, callback: (url: string) => void) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result as string));
  reader.readAsDataURL(img);
};

const beforeUpload = (file: RcFile) => {
  const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  if (!isJpgOrPng) {
    notification.error({ message: "Bạn chỉ có thể tải định dạng JPG/PNG!" });
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    notification.error({ message: "Ảnh phải ít hơn 2MB!" });
  }
  return isJpgOrPng && isLt2M;
};

const schema = yup.object().shape({
  phone: yup
    .number()
    .required()
    .typeError('Number only.')
    .test('isPhoneNumber', 'Phone number must have 10 digits', (value: any) => {
      return /^\d{9}$/.test(value);
    })
  ,
  email: yup
    .string()
    .required()
    .test("", "Email is not valid", (values: any) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(values)
    })
  ,
  age: yup
    .number()
    .required()
    .typeError('Number only.')
    .positive()
    .integer()
    .round()
    .min(6)
    .max(12)
  ,
});

const yupSync = {
  async validator({ field }: { field: string }, value: any) {
    await schema.validateSyncAt(field, { [field]: value });
  },
  type: 'custom',
};


function CardUserInfo({ listUserInfo, IdUserInfo, openCardUser }: { listUserInfo: any; IdUserInfo: any; openCardUser: (result: any) => void }) {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [useInfo, setUseInfo] = useState<UserInfo | undefined>()
  const [edit, setEdit] = useState<boolean>(false);
  const [form] = Form.useForm();
  console.log(useInfo)


  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState<string>(''); // Use optional chaining to handle undefined

  useEffect(() => {
    let data = listUserInfo.find((user: any) => user.id === IdUserInfo);
    setUseInfo(data);
    setImageUrl(data?.srcImage);
    console.log(useInfo)
  }, [listUserInfo, IdUserInfo])

  const handleChange: UploadProps["onChange"] = (
    info: UploadChangeParam<UploadFile>
  ) => {
    if (info.file.status === "uploading") {
      setLoading(true);
      return;
    }
    if (info.file.status === "done") {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj as RcFile, (url) => {
        setLoading(false);
        setImageUrl(url);
      });
    }
  };
  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );


  const handleButtonSave = () => {
    form.submit()
  }

  const handleFinish = (values: any) => {
    // const updatedValues = {
    //   ...values,
    //   id: useInfo?.id,
    //   srcImage: imageUrl
    // };

    // const listUserInfoAfter = listUserInfo.map((item: any) =>
    //   item.id === useInfo?.id ? { ...item, ...updatedValues } : item
    // );

    // setUseInfo(updatedValues)
    // dispatch(UpdateListUserInfo(listUserInfoAfter));
    // setEdit(false)
  };

  const handleChangeEdit = () => {
    setEdit((preEdit) => !preEdit);
    form.resetFields();
  };

  return (
    <Col
      lg={{ span: 24 }}
      style={{
        backgroundColor: "white",
        margin: "5% 13% 0 13%",
        padding: "1% 3% 1% 3%",
        boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.2)",
      }}
    >
      <Row>
        <Col lg={{ span: 20 }}>
          <Title level={3}> Anh Vũ </Title>
        </Col>

        <Col lg={{ span: 4 }} style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
          <CloseOutlined onClick={() => openCardUser(false)} />
        </Col>
      </Row>

      {/* <Row>
        <Col lg={{ span: 18 }}>
          <Title level={5} style={{ margin: 0 }}>
            {t(translations.user.detail)}
          </Title>
        </Col>

        {edit ? (
          <Col lg={{ span: 6 }}>
            <Row gutter={[16, 0]}>
              <Col lg={{ span: 12 }}>
                <Button type="primary" htmlType="submit" onClick={handleButtonSave}>
                  {t(translations.user.save)}
                </Button>
              </Col>
              <Col lg={{ span: 12 }}>
                <Button onClick={handleChangeEdit}>Back</Button>
              </Col>
            </Row>
          </Col>
        ) : (
          <Col style={{ marginLeft: "0%" }} lg={{ span: 6 }}>
            <Button onClick={handleChangeEdit}>
              <EditOutlined />
              {t(translations.user.edit)}
            </Button>
          </Col>
        )}
      </Row> */}

      <Row gutter={[24, 0]} style={{ marginBottom: "5%" }}>
        <Col lg={{ span: 12 }} style={{ padding: 0 }}>
          {edit ? (
            <Col lg={{ span: 24 }}>
              <Upload
                name="avatar"
                listType="picture-circle"
                className="avatar-uploader"
                showUploadList={false}
                action="https://run.mocky.io/v3/435e224c-44fb-4773-9faf-380c5e6a2188"
                beforeUpload={beforeUpload}
                onChange={handleChange}
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "red",
                }}
              >
                {imageUrl ? (
                  <Image
                    src={imageUrl}
                    preview={false}
                    style={{
                      width: "210px",
                      height: "260px",
                      objectFit: "cover",
                      border: "1px solid #e0e0e0",
                      borderRadius: 8,
                    }}
                  />
                ) : (
                  uploadButton
                )}
              </Upload>
            </Col>
          ) : (
            <Col lg={{ span: 24 }}>
              <Image
                style={{
                  width: "100%",
                  height: "260px",
                  objectFit: "cover",
                  objectPosition: "top",
                  border: "1px solid #e0e0e0",
                  borderRadius: 8,
                }}
                src={imageUrl}
                fallback="data:image/png;base64,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"
              ></Image>
            </Col>
          )}
        </Col>

        <Col lg={{ span: 12 }}>
          <Form form={form} initialValues={useInfo} onFinish={(values) => handleFinish(values)} layout="vertical">
            <Form.Item label={t(translations.user.status)} name={"status"} hasFeedback rules={[{ required: true }]}>
              {edit ? <Input></Input> : <Text>{useInfo?.attributes?.active}</Text>}
            </Form.Item>
            <Form.Item label={t(translations.user.firstName)} name={"firstName"} hasFeedback rules={[{ required: true }]}>
              {edit ? <Input></Input> : <Text>{useInfo?.attributes?.firstName}</Text>}
            </Form.Item>
            <Form.Item label={t(translations.user.lastName)} name={"lastName"} hasFeedback rules={[{ required: true }]}>
              {edit ? <Input></Input> : <Text>{useInfo?.attributes?.lastName}</Text>}
            </Form.Item>
          </Form>
        </Col>
      </Row>

      <Row>
        <Col lg={{ span: 24 }}>
          <Form form={form} initialValues={useInfo} onFinish={(values) => handleFinish(values)} layout="vertical">
            <Row gutter={[24, 0]}>
              <Col lg={{ span: 12 }}>
                <Form.Item label={t(translations.user.position)} name={"position"} hasFeedback rules={[{ required: true }]}>
                  {edit ? <Input></Input> : <Text>{useInfo?.attributes?.roleAssignmentText}</Text>}
                </Form.Item>
              </Col>
              {/* <Col lg={{ span: 12 }}>
                <Form.Item label={t(translations.user.assignedTo)} name={"assignedTo"} hasFeedback rules={[{ required: true }]}>
                  {edit ? <Input></Input> : <Text>{useInfo?.attributes?.assignedTo}</Text>}
                </Form.Item>
              </Col> */}
            </Row>
            <Row>
              <Col lg={{ span: 24 }}>
                <Form.Item label={t(translations.user.company)} name={"company"} hasFeedback rules={[{ required: true }]}>
                  {edit ? <Input></Input> : <Text>{useInfo?.attributes?.company}</Text>}
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>

      <Row style={{ marginBottom: "2%" }}>
        <Col
          lg={{ span: 24 }}
          style={{
            paddingBottom: "2%",
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <Title level={5}>{t(translations.user.contacts)}</Title>
        </Col>
      </Row>

      <Row>
        <Col lg={{ span: 24 }}>
          <Form form={form} initialValues={useInfo} onFinish={(values) => handleFinish(values)} layout="vertical">
            {/* <Row>
              <Col lg={{ span: 24 }}>
                <Form.Item label={t(translations.user.address)} name={"address"} hasFeedback rules={[{ required: true }]}>
                  {edit ? <Input></Input> : <Text>{useInfo?.address}</Text>}
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[24, 0]}>
              <Col lg={{ span: 12 }}>
                <Form.Item label={t(translations.user.city)} name={"city"} hasFeedback rules={[{ required: true }]}>
                  {edit ? <Input></Input> : <Text>{useInfo?.city}</Text>}
                </Form.Item>
              </Col>
              <Col lg={{ span: 6 }}>
                <Form.Item label={t(translations.user.state)} name={"state"} hasFeedback rules={[{ required: true }]}>
                  {edit ? <Input></Input> : <Text>{useInfo?.state}</Text>}
                </Form.Item>
              </Col>
              <Col lg={{ span: 6 }}>
                <Form.Item label={t(translations.user.zipCode)} name={"zipCode"} hasFeedback rules={[{ required: true }]}>
                  {edit ? <Input></Input> : <Text>{useInfo?.attributes?.zipCode}</Text>}
                </Form.Item>
              </Col>
            </Row> */}
            <Row gutter={[24, 0]}>
              <Col lg={{ span: 12 }}>
                <Form.Item label={t(translations.user.phone)} name={"phone"} rules={[{ required: true }, yupSync as any]} hasFeedback>
                  {edit ? <Input></Input> : <Text>{useInfo?.attributes?.phoneNumber}</Text>}
                </Form.Item>
              </Col>
              <Col lg={{ span: 12 }}>
                <Form.Item label={t(translations.user.email)} name={"email"} rules={[{ required: true }, yupSync as any]} hasFeedback>
                  {edit ? <Input></Input> : <Text>{useInfo?.attributes?.email}</Text>}
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </Col>
  );
}

export default CardUserInfo;
